const fieldValidation = {
  required: '{{fieldName}} は必須です',
  pattern: '{{fieldName}} が無効です',
  min: '{{fieldName}} は {{value}} 以上で入力してください',
  max: '{{fieldName}} は {{value}} 以下で入力してください',
  minDate: '{{fieldName}} は {{value}} より前の日付は指定できません',
  maxDate: '{{fieldName}} は {{value}} より後の日付は指定できません',
  channelUnlinked:
    '選択したチャンネルとの連携が解除されています。他のチャンネルを選択するか、チャンネルを再連携してください',
};

export default fieldValidation;
